import * as TypeGraphQL from "type-graphql";
export var AnalyticsConfigurationScalarFieldEnum;
(function (AnalyticsConfigurationScalarFieldEnum) {
    AnalyticsConfigurationScalarFieldEnum["id"] = "id";
    AnalyticsConfigurationScalarFieldEnum["configKey"] = "configKey";
    AnalyticsConfigurationScalarFieldEnum["configType"] = "configType";
    AnalyticsConfigurationScalarFieldEnum["configValue"] = "configValue";
    AnalyticsConfigurationScalarFieldEnum["symbol"] = "symbol";
    AnalyticsConfigurationScalarFieldEnum["metadata"] = "metadata";
    AnalyticsConfigurationScalarFieldEnum["createdAt"] = "createdAt";
    AnalyticsConfigurationScalarFieldEnum["updatedAt"] = "updatedAt";
})(AnalyticsConfigurationScalarFieldEnum || (AnalyticsConfigurationScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AnalyticsConfigurationScalarFieldEnum, {
    name: "AnalyticsConfigurationScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AnalyticsConfigurationScalarFieldEnum.js.map